import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import Icon from "../../../components/Icon"

function InstallationsInfoModal({ showSignal, handleCancel, referenceGuid, userCanEditIn4mUtgInstallations}) {

	// const userCanEditIn4mUtgInstallations = false

	return (
		<Modal show={showSignal.value} onHide={handleCancel}>
			<Modal.Header closeButton>
				<Modal.Title>About Installations</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>The Installations tab shows a table containing all the installation packages created for this account. Installation packages (when ran) are used to either connect an existing UTG to Shift4 Command Center so that it may be managed through the Shift4 Command Center application, or to install a new UTG on a machine and connect it to Shift4 Command Center. Any UTG installed using an installation package from this account will be connected to this account in Shift4 Command Center upon completion.</p>
				<br/>
				{ 
					userCanEditIn4mUtgInstallations && (
						<>
							<p><b>Creating an Installation Package</b></p>
							<p>Click <Button size="sm" variant="outline-secondary" className="align-items-center justify-content-center"><Icon icon='plus-circle' width="16" height="16" ></Icon>&nbsp;New</Button> to select the desired type of installation package. A selection can be made by clicking Connect an Existing UTG or Install and Connect a New UTG. The wizard will prompt for the required fields depending on the installation package type being created.</p>
							<br/>
						</>
					)
				}
				<p>For more information, click <b>Reference Guide.</b></p>
			</Modal.Body>
			<Modal.Footer>
				<Button type="button" style={{ fill: "white" }} onClick={() => { window.open(referenceGuid) }}>
					<Icon icon="book" height={16} width={16}></Icon>&nbsp;&nbsp;Reference Guide
				</Button>
				<Button variant='outline-secondary' type="button" onClick={handleCancel}>Close</Button>
			</Modal.Footer>
		</Modal>
    )
}

export default InstallationsInfoModal